export function formatZone(dataLivraison: any) {
    if (
        !dataLivraison?.stZoneLivraison ||
        !Array.isArray(dataLivraison.stZoneLivraison)
    ) {
        return [];
    }

    let data: any[] = [];

    dataLivraison.stZoneLivraison.forEach((element: any) => {
        data.push({
            DebutDistance: element.DebutDistance,
            FinDistance: element.FinDistance,
            MinCommande: element.MinCommande,
            FraisLivraison: element.FraisLivraison,
            idTva: Number(element.idTva),
            TauxTva: Number(element.TauxTva),
            detailsZone: `\u001bPG+De ${element.DebutDistance}km à ${element.FinDistance}km \u001bPG-: Frais liv : ${element.FraisLivraison} € \u001bPG- - Min CMD : ${element.MinCommande} €`,
            infoZone: `\u001bPG+De ${element.DebutDistance}km à ${element.FinDistance}km :\u001bPG- (Frais de liv:${element.FraisLivraison} € - Min commande:${element.MinCommande} €)`,
        });
    });

    return data;
}

export const mapTva: Record<string, string> = {
    "20": "2",
    "10": "1",
    "5.5": "3",
};

export function getCodePays(codeList: any, countryData: string): string | null {
    for (const el of codeList) {
        if (el.pays === countryData) {
            return el.code;
        }
    }
    return null; // if not found
}

export function removeLeadingZeros(number: string): number {
    let result: string = parseInt(number, 10).toString();
    if (result.includes(".")) {
        return parseFloat(result);
    } else {
        return parseInt(result, 10);
    }
}
export async function submitZoneData(
    apiUrl: string,
    payload: any,
    mutate: any
) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    };

    const response = await fetch(apiUrl, requestOptions);
    const data = await response.json();

    if (data.error) {
        throw new Error("API Error");
    }

    return mutate(apiUrl, data);
}

export function getTvaId(tva: string, listTva: any[]): string | undefined {
    const tvaMap: Record<string, string> = {
        "20": "2",
        "10": "1",
        "5.5": "3",
    };

    if (tvaMap[tva]) {
        return tvaMap[tva];
    }

    const nonStandardTva = listTva.find(
        (el) => !["20", "10", "5.5"].includes(el.value)
    );
    return nonStandardTva?.id;
}

export function createZoneDetails(
    remoteDebut: number,
    endDistance: number,
    shippingCosts: number,
    minimumAmount: number
) {
    return {
        detailsZone: `\u001bPG+De ${remoteDebut}km à ${endDistance}km \u001bPG-: Frais liv : ${shippingCosts} € \u001bPG- - Min CMD : ${minimumAmount} €`,
        infoZone: `\u001bPG+De ${remoteDebut}km à ${endDistance}km :\u001bPG- (Frais de liv:${shippingCosts} € -Min commande:${minimumAmount}€)`,
    };
}

export function resetFormState(setters: any) {
    const {
        setIsLoading,
        setShippingCosts,
        setRemoteDebut,
        setEndDistance,
        setMinimumAmount,
        setCountryData,
        setDataIsUpdated,
        setIsEdited,
        setLocalFilterActive,
        setTva,
        clearData,
        clearMultiCustomSelectionData,
        setIsClickedBouttonValider,
    } = setters;

    setIsLoading(false);
    setShippingCosts(0);
    setRemoteDebut(0);
    setEndDistance(0);
    setMinimumAmount(0);
    setCountryData("");
    setDataIsUpdated?.(true);
    setIsEdited(false);
    setLocalFilterActive(false);
    setTva?.("");
    clearData();
    clearMultiCustomSelectionData();
    setIsClickedBouttonValider(true);
}
